function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Layer_1",
    x: "0px",
    width: 20,
    height: 20,
    y: "0px",
    viewBox: "0 0 508.464 508.464",
    style: {
      enableBackground: "new 0 0 508.464 508.464"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_66_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "rgb(0,0,0)"
    },
    points: "46.837,217.093 31.837,217.093 31.837,42.451 79.132,42.451 79.132,57.451 46.837,57.451 "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 31.837,
    y: 264.847,
    style: {
      fill: "rgb(0,0,0)"
    },
    width: 15,
    height: 15.918
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "rgb(0,0,0)"
    },
    points: "476.628,343.979 421.373,343.979 421.373,328.979 461.628,328.979 461.628,304.642 476.628,304.642 "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 461.169,
    y: 42.451,
    style: {
      fill: "rgb(0,0,0)"
    },
    width: 15.918,
    height: 15
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "rgb(0,0,0)"
    },
    points: "341.782,10.615 341.782,25.615 493.464,25.615 493.464,360.815 389.996,360.815 389.996,429.8 321.012,360.815 187.453,360.815 86.632,461.636 86.632,375.815 110.969,375.815 110.969,360.815 86.632,360.815 79.132,360.815 15,360.815 15,25.615 317.905,25.615 317.905,10.615 0,10.615 0,375.815 71.632,375.815 71.632,497.849 193.666,375.815 314.799,375.815 404.996,466.012 404.996,375.815 508.464,375.815 508.464,10.615 "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 126.887,
    y: 360.815,
    style: {
      fill: "rgb(0,0,0)"
    },
    width: 15.918,
    height: 15
  }), /*#__PURE__*/React.createElement("rect", {
    x: 31.837,
    y: 233.01,
    style: {
      fill: "rgb(0,0,0)"
    },
    width: 15,
    height: 15.918
  }), /*#__PURE__*/React.createElement("rect", {
    x: 31.837,
    y: 296.683,
    style: {
      fill: "rgb(0,0,0)"
    },
    width: 15,
    height: 15.918
  }), /*#__PURE__*/React.createElement("rect", {
    x: 461.169,
    y: 74.288,
    style: {
      fill: "rgb(0,0,0)"
    },
    width: 15.918,
    height: 15
  }), /*#__PURE__*/React.createElement("rect", {
    x: 429.332,
    y: 42.451,
    style: {
      fill: "rgb(0,0,0)"
    },
    width: 15.918,
    height: 15
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "rgb(0,0,0)"
    },
    d: "M183.538,302.775c23.01,16.542,50.208,25.286,78.653,25.286 c74.354,0,134.846-60.492,134.846-134.846S336.546,58.369,262.191,58.369s-134.846,60.492-134.846,134.846 c0,37.43,14.965,72.213,42.138,97.941l10.313-10.892c-24.15-22.867-37.45-53.781-37.45-87.049 c0-66.083,53.763-119.846,119.846-119.846s119.846,53.763,119.846,119.846s-53.763,119.846-119.846,119.846 c-25.284,0-49.454-7.769-69.897-22.466L183.538,302.775z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "rgb(0,0,0)"
    },
    d: "M213.978,256.888c0-26.585,21.629-48.214,48.214-48.214s48.214,21.629,48.214,48.214h15 c0-34.856-28.357-63.214-63.214-63.214s-63.214,28.357-63.214,63.214H213.978z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "rgb(0,0,0)"
    },
    d: "M245.813,153.42c0-12.913-10.505-23.418-23.418-23.418s-23.418,10.505-23.418,23.418 s10.505,23.418,23.418,23.418S245.813,166.332,245.813,153.42z M213.978,153.42c0-4.642,3.776-8.418,8.418-8.418 s8.418,3.776,8.418,8.418s-3.776,8.418-8.418,8.418S213.978,158.061,213.978,153.42z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "rgb(0,0,0)"
    },
    d: "M325.405,153.42c0-12.913-10.506-23.418-23.419-23.418s-23.418,10.505-23.418,23.418 s10.505,23.418,23.418,23.418S325.405,166.332,325.405,153.42z M293.568,153.42c0-4.642,3.776-8.418,8.418-8.418 c4.643,0,8.419,3.776,8.419,8.418s-3.776,8.418-8.419,8.418C297.345,161.838,293.568,158.061,293.568,153.42z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPity);
export default __webpack_public_path__ + "static/media/pity.f17f7bc5f343db2613575e18da5fca12.svg";
export { ForwardRef as ReactComponent };